/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Example_FormulaInputs */

const ja_playdata_pricing_example_formula = /** @type {(inputs: Playdata_Pricing_Example_FormulaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本料金 80,000円 + (3,500 x 17日) = 139,500円`)
};

const en_playdata_pricing_example_formula = /** @type {(inputs: Playdata_Pricing_Example_FormulaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base fee ¥80,000 + (¥3,500 × 17 days) = ¥139,500`)
};

/**
* | output |
* | --- |
* | "Base fee ¥80,000 + (¥3,500 × 17 days) = ¥139,500" |
*
* @param {Playdata_Pricing_Example_FormulaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_example_formula = /** @type {((inputs?: Playdata_Pricing_Example_FormulaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Example_FormulaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_example_formula(inputs)
	return en_playdata_pricing_example_formula(inputs)
});